exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._33Fu6n_1cw6LHrVigRwDNO{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._2DzZLT0f2z24MfJVRx8bQ4{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", ""]);

// exports
exports.locals = {
	"enrollDomain_container": "_33Fu6n_1cw6LHrVigRwDNO",
	"domain_btn_container": "_2DzZLT0f2z24MfJVRx8bQ4"
};